import styled from "@emotion/styled";
import { Modal } from "@mui/material";

import { ZIndexLayer } from "shared/lib/styles";

export const StyledModal = styled(Modal)`
  z-index: ${ZIndexLayer.Modal};

  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-tap-highlight-color: transparent;

  *,
  *::before,
  *::after {
    box-sizing: border-box;

    outline: none;
  }
`;
